import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div
        className="max-w-md w-full rounded-3xl p-8 border border-white/10 text-center"
        style={{ background: 'linear-gradient(180deg,rgba(20,20,25,.92),rgba(10,10,14,.98))', backdropFilter: 'blur(24px)' }}
        data-testid="payment-cancel-page"
      >
        <div className="flex flex-col items-center gap-4">
          <XCircle className="w-14 h-14 text-white/40" />
          <h1 className="text-2xl font-light tracking-tight">Pagamento cancelado</h1>
          <p className="text-white/50 text-sm">
            Nenhum valor foi cobrado. Você pode iniciar uma nova compra quando quiser.
          </p>
          <button
            onClick={() => navigate('/')}
            data-testid="payment-back-home"
            className="mt-6 px-8 py-3 rounded-full bg-white/10 text-white text-sm tracking-wide font-medium hover:bg-white/15 transition"
          >
            Voltar ao WClub
          </button>
        </div>
      </div>
    </div>
  );
}
